import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getNestedProperty',
  standalone: true,
})
export class GetNestedPropertyPipe implements PipeTransform {
  transform(value: any, keyPath: string): string {
    try {
      const res = keyPath.split('.').reduce((acc, key) => acc?.[key], value);
      return res;
    } catch (e) {
      console.error(e);
      return 'Key error';
    }
  }
}
